<template lang="html">
  <div class="token-translation">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleTokenTranslation','titleTokenTranslation') }}</h6>

          <div class="element-box">
            <div class="element-info">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <fontAwesomeIcon  :icon="['fas', 'language']" class="text-primary" size="1x"/>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleTokenTranslation','titleTokenTranslation') }}</h5>
                      <div class="element-inner-desc">{{ t('tokenTranslationDesc','tokenTranslationDesc') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <label for="token-translation" class="d-block text-center">{{ t('selectAlanguage','selectAlanguage') }}</label>
                <b-form-select id="token-translation" v-model="chosenLanguage" >
                  <b-form-select-option :value="null">{{t('optionSelectALanguage', 'optionSelectALanguage')}}</b-form-select-option>
                  <b-form-select-option v-for="(language, index) in allowedLanguages" :key="index" :value="index">{{t(language,language)}}</b-form-select-option>
                </b-form-select>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 align-self-end">
                <button class="btn btn-primary ml-2" :disabled="!chosenLanguage" @click="modalCreator({id: 'addTokenModal', title: t('addNewTokenModalHead', 'addNewTokenModalHead'), open: 'open'},{language: chosenLanguage}, $event.target)" >
                {{ t('addNewToken','addNewToken') }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="tokenTranslations.total && searched" class="element-box">

            <div v-if="tokenTranslations.total" class="controls-below-table pb-4 row">
                <div class="table-records-info col-lg-6 col-sm-12 align-self-center" v-if="tokenTranslations.total">
                  <p class="mb-0">
                    <template v-if="tokenTranslations.total == 1">
                    {{tokenTranslations.total}} {{ t('tokenTranslationFoundLabel','tokenTranslationFoundLabel') }}
                    </template>
                    <template v-else>
                    {{tokenTranslations.total}} {{ t('tokenTranslationsFoundLabel','tokenTranslationsFoundLabel') }}
                    </template>
                  </p>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <b-pagination v-if="tokenTranslations.total" ref="paginationTop" class="float-right mb-0" v-model="page" :total-rows="tokenTranslations.total" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
                <div class="col-lg-2 col-sm-12 text-right">
                  <b-input-group class="col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
            </div>

            <b-table striped hover responsive :fields="fields" no-sort-reset :items="tokenTranslations.tokens" :thead-class="'brand-color'">
              <template v-slot:head(token)="data">
                <span> {{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(translation)="data">
                <span> {{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(content)="data">
                <span> {{ t(data.label, data.label) }}</span>
              </template>
              <template v-slot:head(actions)="data">
                <span> {{ t(data.label, data.label) }}</span>
              </template>
              <template class="busy-row" v-slot:table-busy>
                <vcl-table v-if="isBusy" :rows="5" :columns="5"></vcl-table>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
              </template>
              <template v-slot:cell(token)="data">
                {{data.item.token}}
              </template>
              <template v-slot:cell(translation)="data">
                {{data.item.translation}}
              </template>
              <template v-slot:cell(content)="data">
                {{data.item.content}}
              </template>
              <template v-slot:cell(actions)="data">
                <div class="col-12 row justify-content-end">
                  <button class="btn btn-primary ml-2" @click="modalCreator({id: 'editTokenModal', title: t('editTokenModalHead', 'editTokenModalHead'), open: 'open'},{id: data.item.id, language: chosenLanguage, data: data.item}, $event.target)" >{{ t('editButtonText','editButtonText') }}</button>
                  <button class="btn btn-danger ml-2" @click="modalCreator({id: 'deleteTokenModal', title: t('deleteTokenModalHead', 'deleteTokenModalHead'), open: 'open'},{id: data.item.id, language: chosenLanguage}, $event.target)" >{{ t('deleteButtonText','deleteButtonText') }}</button>
                </div>
              </template>
            </b-table>

            <div v-if="tokenTranslations.total" class="controls-below-table pt-4 row">
                <div class="table-records-info col-lg-6 col-sm-12 align-self-center" v-if="tokenTranslations.total">
                  <p class="mb-0">
                    <template v-if="tokenTranslations.total == 1">
                    {{tokenTranslations.total}} {{ t('tokenTranslationFoundLabel','tokenTranslationFoundLabel') }}
                    </template>
                    <template v-else>
                    {{tokenTranslations.total}} {{ t('tokenTranslationsFoundLabel','tokenTranslationsFoundLabel') }}
                    </template>
                  </p>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <b-pagination v-if="tokenTranslations.total" ref="paginationBottom" class="float-right mb-0" v-model="page" :total-rows="tokenTranslations.total" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
                <div class="col-lg-2 col-sm-12 text-right">
                  <b-input-group class="col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalAddToken/>
    <ModalDeleteToken/>
    <ModalEditToken/>
    <div v-if="this.modal['modalData'].open" class="modal-backdrop show"></div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalEditToken from '@/components/Token_Translation/ModalEditToken.vue'
import ModalAddToken from '@/components/Token_Translation/ModalAddToken.vue'
import ModalDeleteToken from '@/components/Token_Translation/ModalDeleteToken.vue'

export default {
  name: 'token_translation',
  provide() {
    return {
        resetModal: this.resetModal,
        modal: this.modal,
        editToken: this.editToken,
        addNewToken: this.addNewToken,
        deleteToken: this.deleteToken
    }
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {key: 'token', label: 'labelToken', tdClass: 'row-size-small', sortable: true},
        {key: 'translation', label: 'labelTranslation', tdClass: 'row-size-big'},
        {key: 'content', label: 'labelContent', tdClass: 'row-size-medium'},
        {key: 'actions', label: 'labelActions', tdClass: 'row-size-medium', thClass: 'text-center'}
      ],
      modal: {
        modalData: {},
        tokenData: {},
        updateData: {}
      },
      perPage: 20,
      pageOptions: [10, 20, 50, 100],
      page: 1,
      chosenLanguage: null,
      searched: false
    }
  },
  computed:{
      ...mapGetters(['getResponseInfo']),
      allowedLanguages() {
        return this.$store.getters['tokenTranslationStore/getAllowedLanguages']
      },
      tokenTranslations: {
        get() {
          return this.$store.getters['tokenTranslationStore/getTokenTranslationsForLanguage']
        },
        set(newDisplaySettings) {
          this.$store.commit('tokenTranslationStore/setTokenTranslations', newDisplaySettings)
        }
      },
      totalRows() {
        return this.tokenTranslations.length
      }
  },
  watch:{
    chosenLanguage(chosen) {
      if((chosen !== null) && (chosen !== undefined)) {
        this.getTokenTranslationsForLanguage(chosen)
        if(this.$router.language && (this.$router.language != chosen)) {
          this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: chosen} })
        }
      } else {
        this.tokenTranslations = []
        this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: undefined} })
      }
    },
    perPage(newNum) {
      if((newNum !== null) && (newNum !== undefined)) {
        if((this.chosenLanguage !== null) && (this.chosenLanguage !== undefined)) {
          this.getTokenTranslationsForLanguage(this.chosenLanguage)
          this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: this.chosenLanguage} })
        } else {
          this.tokenTranslations = []
          this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: undefined} })
        }
      }
    },
    page(newPage) {
      if((newPage !== null) && (newPage !== undefined)) {
        if((this.chosenLanguage !== null) && (this.chosenLanguage !== undefined)) {
          this.getTokenTranslationsForLanguage(this.chosenLanguage)
          this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: this.chosenLanguage} })
        } else {
          this.tokenTranslations = []
          this.$router.push({ query: { ...this.$route.query, page: this.page, per_page: this.perPage, language: undefined} })
        }
      }
    }
  },
  methods: {
    getTokenTranslationsForLanguage(chosen) {
      this.$store.dispatch('tokenTranslationStore/getTokenTranslationsForLanguage', {
        language: chosen,
        page: this.page,
        perPage: this.perPage
      }).then(() => {
        this.searched = true
      })
    },
    addNewToken(newTokenData, language, button) {
      this.isBusy = true
      newTokenData.language = language
      this.$store.dispatch('tokenTranslationStore/addTokenTranslation', newTokenData)
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.getTokenTranslationsForLanguage(this.chosenLanguage)
          this.isBusy = false

          this.$root.$emit('bv::hide::modal', 'addTokenModal', button)
        }
      })
    },
    deleteToken(tokenId, languageCode, button) {
      this.isBusy = true
      this.$store.dispatch('tokenTranslationStore/deleteTokenTranslation', {language: languageCode, token: tokenId})
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.getTokenTranslationsForLanguage(this.chosenLanguage)
          this.isBusy = false
          this.$root.$emit('bv::hide::modal', 'deleteTokenModal', button)
        }
      })
    },
    editToken(tokenId, languageCode, updateData, button) {
      this.isBusy = true
      this.$store.dispatch('tokenTranslationStore/editTokenTranslation', {tokenId: tokenId, token: updateData.token, language: languageCode, content: updateData.content, translation: updateData.translation})
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.getTokenTranslationsForLanguage(this.chosenLanguage)
          this.isBusy = false
          this.$root.$emit('bv::hide::modal', 'editTokenModal', button)
        }
      })
    },
    //MODALS
    modalCreator(modalData, tokenData, button) {
      this.modal.modalData = modalData
      this.modal.tokenData = { ...tokenData }
      if(modalData.id == 'editTokenModal') {
        this.modal.updateData = { ...tokenData.data }
      }
      this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
    },
    resetModal() {
      Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
      Object.keys(this.modal['tokenData']).forEach((key) => (this.modal['tokenData'][key] = '' ))
      Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
      this.$store.dispatch('alertClearResponse')
    }
  },
  created() {
    this.searched = false

    if(Object.keys(this.$route.query).length) {
      //Pagination setup
      if(this.$route.query.page) {
        this.page = parseInt(this.$route.query.page)
      } else {
        this.page = 1
      }

      if(this.$route.query.per_page) {
        this.perPage = parseInt(this.$route.query.per_page)
        if(!this.pageOptions.includes(this.$route.query.per_page)) {
          this.pageOptions.push(this.$route.query.per_page)
        }
      } else {
        this.perPage = 20
      }

      if(this.$route.query.language) {
        if(this.chosenLanguage != this.$route.query.language) {
          this.chosenLanguage = this.$route.query.language
        }
      }

    } else {
      this.page = 1
      this.perPage = 20
    }

    //fetching allowed languages
    this.$store.dispatch('tokenTranslationStore/getAllowedLanguages')

  },
  components: {
    ResponseInfo,
    ModalEditToken,
    ModalAddToken,
    ModalDeleteToken
  }
}
</script>

<style lang="css" scoped>
/*TABLE*/
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.table-responsive  >>> .row-size-small {
  width: 10% !important;
}

.table-responsive  >>> .row-size-medium {
  width: 25% !important;
}

.table-responsive  >>> .row-size-big {
  width: 40% !important;
}
</style>
